/*
 * @overview: 数据上报
 * @Created by: zhuyikai
 * @Copyright: Copyright © 2020 找我婚礼. All rights reserved.
 * @Date: 2023-03-27 18:18:21
 */

import { options } from "./options";
import { deviceInfo, objectToUrlParams } from "../utils";

class SendTracker {
  constructor() {
    this.xhr = new XMLHttpRequest();
  }
  /**
   * 上报
   * @param data 采集到的需上报信息
   */
  send(data = {}, type = null) {
    options.apiSending = Date.now();
    // 如果是自定义 则设置类型为 CUSTOM
    if (type) data = { ...data, type: "CUSTOM" };

    // 用户设备信息
    const userAgent = deviceInfo();
    const { api, method } = options;
    let extraData = {
      timestamp: Date.now(),
      ...userAgent,
    };
    let log = { __topic__: data.type, ...extraData, ...data };
    // SLS中 对象key不能为数字
    for (const key in log) {
      if (typeof log[key] === "number") {
        log[key] = `${log[key]}`;
      }
    }
    let params = objectToUrlParams(log);

    let url = `${api}?APIVersion=0.6.0&${params}`;
    this.xhr.open(method, url, true);
    this.xhr.onload = () => {
      console.log(`webcrawling 上报成功`);
    };
    this.xhr.onerror = (error) => {
      console.error(`webcrawling 上报出错：`, error);
    };
    this.xhr.send();
  }
}

const tracker = new SendTracker();

export { tracker };
